<template>
  <div>
    <app-bar ref="refAppBar" @on_back="onBack" @bulk_copy="bulkCopy"></app-bar>
    <v-container fluid>
      <v-row>
        <v-col cols="12" md="6">
          <div class="text-subtitle-2 pa-1 blue--text blue lighten-5 mb-2">
            媒体個別項目・Q&Aを複写する媒体(複写元と複写先)を選択して下さい。
          </div>
          <div>
            <h3 class="mb-2">コピー元の媒体</h3>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-select
                    prepend-icon="mdi-web"
                    v-model="copyFromShopSiteId"
                    :items="copyFromShopSites"
                    item-value="id"
                    item-text="site_name"
                    no-data-text="コピー機能に対応した媒体が見つかりません。"
                    label="媒体選択"
                    success
                    outlined
                  ></v-select>
                </v-col>
              </v-row>
            </v-container>
            <div class="text-center">
              <v-icon class="mb-8" size="24">mdi-arrow-down-bold</v-icon>
            </div>
            <h3 class="mb-2">コピー先の媒体</h3>
            <v-container>
              <v-data-table
                id="copy_to_shopsite_table"
                :headers="copyToShopSiteHeaders"
                :items="copyToShopSites"
                item-key="id"
                show-select
                :single-select="false"
                v-model="copyToShopSiteSelected"
                :mobile-breakpoint="0"
                :items-per-page="-1"
                :footer-props="{
                  'items-per-page-options': [50, 100, -1],
                  'items-per-page-text': '表示件数',
                }"
                @click:row="rowClick"
              >
                <!-- eslint-disable-next-line -->
                <template v-slot:footer.page-text="props">
                  {{ props.pageStart }} ～{{ props.pageStop }}件／全{{
                    props.itemsLength
                  }}件
                </template>
                <!-- eslint-disable-next-line -->
                <template v-slot:item.name="{ item }">
                  {{ item.site_name }}
                </template>
                <template v-slot:no-data>
                  コピー先の媒体が見つかりません
                </template>
              </v-data-table>
            </v-container>
          </div>
        </v-col>
        <v-col cols="12" md="6">
          <div class="text-subtitle-2 pa-1 orange--text orange lighten-5 mb-2">
            複写したいセラピストをチェックをしてください。
          </div>
          <h3 id="cast_sync_step1">セラピスト選択</h3>
          <div class="mt-2 mb-2">
            コピー先の<span class="text-blue font-bold">媒体個別項目</span
            >と<span class="text-blue font-bold">Q&A</span
            >に対して、コピー元の内容で上書きします。
          </div>
          <v-row>
            <v-col cols="6"></v-col>
            <v-col cols="6">
              <div>
                <v-text-field
                  v-model="castSearch"
                  append-icon="mdi-magnify"
                  label="（セラピスト名検索）"
                  single-line
                  hide-details
                  clearable
                  dense
                  class="mb-2"
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
          <v-data-table
            id="cast_table"
            :headers="castHeaders"
            :items="casts"
            :search="castSearch"
            item-key="id"
            show-select
            :single-select="false"
            v-model="castSelected"
            :mobile-breakpoint="0"
            :items-per-page="-1"
            :footer-props="{
              'items-per-page-options': [50, 100, -1],
              'items-per-page-text': '表示件数',
            }"
            @click:row="rowClick"
          >
            <!-- eslint-disable-next-line -->
            <template v-slot:footer.page-text="props">
              {{ props.pageStart }} ～{{ props.pageStop }}件／全{{
                props.itemsLength
              }}件
            </template>
            <!-- 名前 -->
            <!-- eslint-disable-next-line -->
            <template v-slot:item.name="{ item }">
              <v-avatar class="ma-1 mr-3"
                ><v-img :src="setting.cdn + item.image"
              /></v-avatar>
              {{ item.name }}
            </template>
            <!-- 公開 -->
            <!-- eslint-disable-next-line -->
            <template v-slot:item.enable="{ item }">
              <div class="pa-1">
                <v-chip
                  v-if="item.is_enable"
                  class="ma-2"
                  color="primary"
                  label
                  small
                >
                  公開中
                </v-chip>
                <v-chip v-else class="ma-2" label small> 非公開 </v-chip>
              </div>
            </template>
            <template v-slot:no-data> セラピストが登録されていません </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>

    <!-- 一括更新ダイアログ -->
    <v-dialog
      v-model="updateDialog"
      scrollable
      persistent
      width="100%"
      max-width="650px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">媒体の情報をコピーします</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <div>
                  <div class="mb-4">
                    コピー元：<span class="text-black">{{
                      copyFromShopSiteId !== 0 &&
                      copyFromShopSites.length > 0 &&
                      copyFromShopSites.find((v) => v.id === copyFromShopSiteId)
                        .site_name
                    }}</span>
                  </div>
                  <div class="mb-4">
                    コピー先：<span class="text-black">{{
                      copyToShopSiteSelected.length > 0 &&
                      copyToShopSiteSelected.map((v) => v.site_name).join(", ")
                    }}</span>
                  </div>
                  <div class="mb-4">
                    対象セラピスト：{{ updatedCast }} /
                    {{ castSelected.length }}
                    <span class="text-blue"
                      >&nbsp;&nbsp;
                      {{ isFinished ? "コピー処理が完了しました。" : "" }}</span
                    >
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-container>
            <v-row justify="end">
              <v-col cols="6" sm="3">
                <general-button btn_color="gray" btn_block @click-event="onBack"
                  ><template v-slot:icon
                    ><v-icon left>mdi-arrow-left-circle</v-icon></template
                  >一覧に戻る</general-button
                >
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="6" sm="3">
                <general-button
                  btn_color="gray"
                  btn_block
                  @click-event="cancelDialog"
                  ><template v-slot:icon
                    ><v-icon left>mdi-close-circle</v-icon></template
                  >閉じる</general-button
                >
              </v-col>
              <v-col cols="6" sm="3">
                <general-button
                  btn_color="info"
                  btn_block
                  @click-event="startUpdate"
                  ><template v-slot:icon
                    ><v-icon left>mdi-content-copy</v-icon></template
                  >処理開始</general-button
                >
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <app-bar ref="refAppBar" @on_back="onBack" @bulk_copy="bulkCopy"></app-bar>
  </div>
</template>

<script>
import {
  set,
  ref,
  reactive,
  toRefs,
  watch,
  defineComponent,
} from "@vue/composition-api";
import { repositoryFactory } from "@/repository/repositoryFactory";
import { useRouter } from "@/utils";
import store from "@/store/index.js";
import setting from "@/common/setting.js";
import utilDate from "@/common/utilDate";

import appBar from "./appBar.vue";
import shopSites from "@/store/modules/shopSites";

export default defineComponent({
  components: {
    appBar,
  },
  setup(props, ctx) {
    const CastsRepository = repositoryFactory.get("casts");
    const CastPropsRepository = repositoryFactory.get("castProps");
    const ShopSitesRepository = repositoryFactory.get("shopSites");

    const { router } = useRouter();
    const refAppBar = ref();

    const state = reactive({
      casts: [],
      castSearch: "",
      castSelected: [],
      castHeaders: [
        {
          text: "セラピスト名",
          value: "name",
          sortable: false,
          class: "td_name",
        },
        { text: "公開/非公開", value: "enable", sortable: false },
      ],
      copyFromShopSites: [],
      copyFromShopSiteId: 0,
      copyToShopSites: [],
      copyToShopSiteSelected: [],
      copyToShopSiteHeaders: [
        {
          text: "コピー先の媒体名",
          value: "site_name",
          sortable: false,
        },
      ],
      // 更新中表示ダイアログ
      updateDialog: false,
      isUpdateing: false,
      updatedCast: 0,
      isFinished: false,
    });

    const init = async () => {
      // ローディング表示
      store.dispatch("loadingIcon/showIcon");

      // システム内の登録セラピストをstoreから取得する
      state.casts.splice(0);
      let params = new URLSearchParams();
      params.append("shop_id", store.getters["shops/currentShop"].id);
      await CastsRepository.list(params)
        .then((response) => {
          if (response.data) {
            Object.keys(response.data).forEach(function (key) {
              state.casts.push(response.data[key]);
            });
          }
        })
        .catch((error) => {
          throw (
            "ERROR:cast/clistTable/index.vue/init CastsRepository.list (" +
            error +
            ")"
          );
        });

      // 更新サイト一覧取得
      state.copyFromShopSites.splice(0);
      params = new URLSearchParams();
      params.append("shop_id", store.getters["shops/currentShop"].id);
      await ShopSitesRepository.list_getcast_update(params)
        .then((response) => {
          if (response.data) {
            Object.keys(response.data).forEach(function (key) {
              state.copyFromShopSites.push({
                "id": response.data[key].id,
                "site_id": response.data[key].site_id,
                "site_name":
                  response.data[key].sites_name +
                  (JSON.parse(response.data[key].config).memo != ""
                    ? " [ " + JSON.parse(response.data[key].config).memo + " ] "
                    : ""),
                "color": JSON.parse(response.data[key].config).color,
              });
            });
            if (state.copyFromShopSites.length > 0) {
              state.copyFromShopSiteId = state.copyFromShopSites[0].id;
            } else {
              state.copyFromShopSiteId = 0;
            }
          }
        })
        .catch((error) => {
          throw "ERROR:データ取得エラー (" + error + ")";
        });

      await store.dispatch("loadingIcon/hideIcon"); // ローディング非表示
    };

    init();

    // セラピスト一覧に戻る
    const onBack = async () => {
      router.push({ name: "cast" });
    };

    // copyFromShopSiteIdが変更されたら、copyToShopSitesを取得する
    watch(
      () => state.copyFromShopSiteId,
      async (newVal) => {
        // ローディング表示
        store.dispatch("loadingIcon/showIcon");

        // 更新サイト一覧取得
        if (newVal == 0) {
          state.copyToShopSites.splice(0);
          state.copyToShopSiteSelected.splice(0);
          await store.dispatch("loadingIcon/hideIcon"); // ローディング非表示
          return;
        }

        state.copyToShopSites.splice(0);
        let params = new URLSearchParams();
        params.append("shop_id", store.getters["shops/currentShop"].id);
        params.append("copy_from_shop_site_id", newVal);
        await ShopSitesRepository.list_copy_item(params)
          .then((response) => {
            if (response.data) {
              Object.keys(response.data).forEach(function (key) {
                state.copyToShopSites.push({
                  "id": response.data[key].id,
                  "site_id": response.data[key].site_id,
                  "site_name":
                    response.data[key].sites_name +
                    (JSON.parse(response.data[key].config).memo != ""
                      ? " [ " +
                        JSON.parse(response.data[key].config).memo +
                        " ] "
                      : ""),
                  "color": JSON.parse(response.data[key].config).color,
                });
              });
              if (state.copyToShopSites.length > 0) {
                Object.keys(state.copyToShopSites).forEach(function (key) {
                  state.copyToShopSiteSelected.push(state.copyToShopSites[key]);
                });
              } else {
                state.copyToShopSiteSelected.splice(0);
              }
            }
          })
          .catch((error) => {
            throw "ERROR:データ取得エラー (" + error + ")";
          });

        await store.dispatch("loadingIcon/hideIcon"); // ローディング非表示
      },
      { immediate: true }
    );

    // 取込ボタン
    const bulkCopy = async () => {
      // 入力チェック
      if (state.copyFromShopSiteId == 0) {
        alert("コピー元の媒体を選択してください。");
        return false;
      }
      if (state.copyToShopSiteSelected.length == 0) {
        alert("コピー先の媒体を選択してください。");
        return false;
      }
      if (state.castSelected.length == 0) {
        alert("コピーしたいセラピストをチェックしてください。");
        return false;
      }
      // ダイアログ表示
      state.updatedCast = 0;
      state.updateDialog = true;
      state.isFinished = false;
    };

    const startUpdate = async () => {
      if (
        !window.confirm(
          "コピーを開始してよろしいですか？\n【注意】コピー先の媒体は上書きされます。\n\n" +
            state.copyFromShopSites.find(
              (v) => v.id === state.copyFromShopSiteId
            ).site_name +
            "\n↓\n" +
            state.copyToShopSiteSelected.map((v) => v.site_name).join("\n")
        )
      ) {
        return false;
      }
      // ローディング表示
      store.dispatch("loadingIcon/showIcon");

      // 更新処理
      for (let i = 0; i < state.castSelected.length; i++) {
        for (let j = 0; j < state.copyToShopSiteSelected.length; j++) {
          const cast = state.castSelected[i];
          const params = {
            shop_id: store.getters["shops/currentShop"]["id"],
            from_shop_site_id: state.copyFromShopSiteId,
            to_shop_site_id: state.copyToShopSiteSelected[j].id,
            cast_id: cast.id,
          };
          await CastPropsRepository.cast_prop_copy(params)
            .then((response) => {
              if (!response.data) {
                alert(response.data.message);
                return false;
              }
            })
            .catch((error) => {
              throw "ERROR:SynchroRepository.sync_cast (" + error + ")";
            });
        }
        state.updatedCast++;
      }

      state.isFinished = true;

      // ローディング非表示
      await store.dispatch("loadingIcon/hideIcon");
    };

    const rowClick = (item, row) => {
      row.select(!row.isSelected);
    };

    // セラピスト一覧に戻る
    const cancelDialog = async () => {
      state.updateDialog = false;
    };

    return {
      setting,
      refAppBar,
      ...toRefs(state),
      onBack,
      bulkCopy,
      rowClick,
      cancelDialog,
      startUpdate,
    };
  },
});
</script>

<style scoped>
::v-deep .mini label {
  font-size: 0.75em;
}
::v-deep .td_name {
  min-width: 200px;
  width: 400px;
}
::v-deep #cast_table thead {
  background-color: #fff3e0 !important;
}
::v-deep #copy_to_shopsite_table thead {
  background-color: #e3f2fd !important;
}
</style>
